// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1-IDJ","infoBtn":"quickbooks_infoBtn__3RqRl","formBox":"quickbooks_formBox__3alKQ","formFooter":"quickbooks_formFooter__3PRWy"};